import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { initGA, logPageView } from "./analytics";

import HomePage from "./homecomponents/HomePage";
import LegalPage from "./homecomponents/LegalPage";
import RegistrationPage from "./homecomponents/RegistrationPage";
import DemoPage from "./homecomponents/DemoPage";
import BoCoCard from "./homecomponents/Cards/BoCoCard";
import BernyCard from "./homecomponents/Cards/BernyCard";
import JoseCard from "./homecomponents/Cards/JoseCard";

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname);
  }, [location]);

  return null;
};

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <>
      <RouteChangeTracker />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/register" element={<RegistrationPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/FrancescBoCo" element={<BoCoCard />} />
        <Route path="/BernatClSa" element={<BernyCard />} />
        <Route path="/JoseIgnacioRoPe" element={<JoseCard />} />
      </Routes>
    </>
  );
}

export default App;
